module.exports = __webpack_public_path__ + "img/4cf54a3.png";